(function () {
  let instance = null;

  function initialize() {
    if (instance) {
      if (instance.request && instance.request.readyState !== 4) instance.request.abort();
      // Ajaxinate has no click listener left after its final page sets this to null.
      if (instance.settings.method !== 'click' || instance.nextPageLinkElement) instance.destroy();
      instance = null;
    }

    const pagination = document.querySelector('#ProductGridContainer .AjaxinatePagination');
    const grid = document.querySelector('#ProductGridContainer .AjaxinateLoop');
    if (!pagination || !grid || !pagination.querySelector('a') || typeof Ajaxinate === 'undefined') return;

    instance = new Ajaxinate({
      container: '#ProductGridContainer .AjaxinateLoop',
      pagination: '#ProductGridContainer .AjaxinatePagination',
      loadingText: '<span class="loader-line"></span>',
      method: pagination.dataset.pagination === 'scroll' ? 'scroll' : 'click',
      callback: function () {
        if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') window.jdgm.customizeBadges();
        if (window.theme) {
          if (theme.collectionView) theme.collectionView.triggerView();
          if (theme.wishlist && theme.wishlist.load) theme.wishlist.load();
          if (theme.compare && theme.compare.load) theme.compare.load();
          if (theme.swatchCard2 && theme.swatchCard2.load) theme.swatchCard2.load();
        }
      }
    });
  }

  document.addEventListener('collection:grid-updated', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
